export default class CoverageRegion {
  constructor(data = {}) {
    this.uniqueId = data.uniqueId;
    this.region = data.region;
    this.name = data.name;
  }
}
